export enum TaskState {
  REQUESTED = 'REQUESTED',
  DEFAULT = 'DEFAULT',
  ORDERED = 'ORDERED',
  FOR_REVIEW = 'FOR_REVIEW',
  ERROR = 'ERROR',
  COMPLETED = 'COMPLETED',
  WAIVED = 'WAIVED',
}
